import React from "react"
import YouTube from "react-youtube"
import { tutorialSteps } from "../common/constants/app_consts"
import { appStrings } from "../common/strings/app_strings.js"
import { appNums } from "../common/nums/app_nums"
const { DEFAULT_VIDEO_WIDTH } = appNums
const { nextButton, doneButton, title: pageTitle } = appStrings.tutorial
const { sort, videoId, playList, items } = tutorialSteps
export class Tutorial extends React.Component {
    constructor() {
        super()

        this.videoPlayer = null
        this.state = {
            step: 1,
            width: "",
        }
    }

    componentDidMount() {
        // compute video width
        const listElement = document.getElementById("button-list")
        const width = listElement
            ? listElement.offsetWidth
            : `${DEFAULT_VIDEO_WIDTH}`
        this.setState({
            width,
        })
    }

    next = () => {
        this.videoPlayer && this.videoPlayer.nextVideo()

        const { step } = this.state
        const currentIndex = sort.indexOf(step)
        const nextStep = sort[currentIndex + 1]
        this.setStep(nextStep)
    }

    setStep = step => {
        this.setState({ step }, () => {
            this.props.setStep && this.props.setStep(step)
        })
    }

    videoStateChange = ({ data }) => {
        const { step } = this.state
        // if the video ends, go to the next video (unless it's the last step)
        if (data === 0 && step !== sort.length - 1) {
            this.next()
        }
    }

    onReady = ({ target }) => {
        this.videoPlayer = target
    }

    render() {
        const { step, width } = this.state
        const { title, subtitle } = items[step]
        const totalSteps = sort.length - 1
        const stepTitle = `${step} / ${totalSteps} - ${title}`
        const isFinalStep = step === totalSteps
        const opts = {
            width: `${width}`,
            height: `${width * 0.51}`,
            playerVars: {
                autoplay: 1,
                playlist: playList,
                modestbranding: 1,
                rel: 0,
            },
        }

        return (
            <div className="tutorial">
                <h4 className="sign-up-welcome-text">{pageTitle}</h4>
                <div className="tutorial-step-wrapper">
                    <p className="tutorial-title">{stepTitle}</p>
                    <p className="tutorial-subtitle">{subtitle}</p>
                    {videoId && width && (
                        <YouTube
                            onStateChange={this.videoStateChange}
                            videoId={videoId}
                            opts={opts}
                            className="youtube-component"
                            onReady={this.onReady}
                        />
                    )}
                </div>
                <div className="button-list" id="button-list">
                    <button
                        onClick={this.next}
                        className="btn btn-primary btn-lg"
                        tabIndex="1"
                    >
                        {isFinalStep ? doneButton : nextButton}
                    </button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/tutorial.jsx